import { render, staticRenderFns } from "./NovaDesignThreeD.vue?vue&type=template&id=6371df86&scoped=true"
import script from "./NovaDesignThreeD.vue?vue&type=script&lang=js"
export * from "./NovaDesignThreeD.vue?vue&type=script&lang=js"
import style0 from "./NovaDesignThreeD.vue?vue&type=style&index=0&id=6371df86&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6371df86",
  null
  
)

export default component.exports